var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-explorer-container" },
    [
      _c("div", { staticClass: "file-explorer-header" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("feather-icon", {
              staticClass: "title-icon",
              attrs: { icon: "HardDriveIcon", size: "18" }
            }),
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ],
          1
        ),
        _c("div", { staticClass: "toolbar" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "drive.upload",
                  expression: "'drive.upload'"
                }
              ],
              staticClass: "toolbar-button",
              class: { "disabled-button": _vm.isRootLevel },
              attrs: {
                disabled: _vm.isRootLevel || _vm.isSharedContext,
                title: "Upload de arquivo"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("show-upload-dialog")
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "UploadIcon", size: "16" } })],
            1
          ),
          _c(
            "button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "drive.create_directory",
                  expression: "'drive.create_directory'"
                }
              ],
              staticClass: "toolbar-button",
              class: { "disabled-button": _vm.isRootLevel },
              attrs: {
                disabled: _vm.isRootLevel || _vm.isSharedContext,
                title: "Nova pasta"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("show-new-folder-dialog")
                }
              }
            },
            [
              _c("feather-icon", {
                attrs: { icon: "FolderPlusIcon", size: "16" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "view-toggle" }, [
            _c(
              "button",
              {
                class: ["toolbar-button", { active: _vm.viewMode === "grid" }],
                attrs: { title: "Visualização em grade" },
                on: {
                  click: function($event) {
                    _vm.viewMode = "grid"
                  }
                }
              },
              [_c("feather-icon", { attrs: { icon: "GridIcon", size: "16" } })],
              1
            ),
            _c(
              "button",
              {
                class: ["toolbar-button", { active: _vm.viewMode === "list" }],
                attrs: { title: "Visualização em lista" },
                on: {
                  click: function($event) {
                    _vm.viewMode = "list"
                  }
                }
              },
              [_c("feather-icon", { attrs: { icon: "ListIcon", size: "16" } })],
              1
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "breadcrumb-container" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c("div", { staticClass: "breadcrumb-nav-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "toolbar-button",
                  class: { active: _vm.treeViewVisible },
                  attrs: { title: "Visualizar estrutura em árvore" },
                  on: { click: _vm.toggleTreeView }
                },
                [
                  _c("feather-icon", {
                    attrs: { icon: "AlignJustifyIcon", size: "14" }
                  })
                ],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "toolbar-button",
                  attrs: {
                    disabled: _vm.currentPath === "",
                    title: "Subir um nível"
                  },
                  on: { click: _vm.navigateUp }
                },
                [
                  _c("feather-icon", {
                    attrs: { icon: "ArrowUpIcon", size: "14" }
                  })
                ],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "toolbar-button",
                  attrs: { title: "Atualizar" },
                  on: { click: _vm.refresh }
                },
                [
                  _c("feather-icon", {
                    attrs: { icon: "RefreshCwIcon", size: "14" }
                  })
                ],
                1
              )
            ]),
            _c(
              "span",
              {
                staticClass: "breadcrumb-item",
                class: { "active-breadcrumb": _vm.currentPath === "" },
                on: { click: _vm.navigateToRoot }
              },
              [
                _c("feather-icon", { attrs: { icon: "HomeIcon", size: "14" } }),
                _c("span", { staticClass: "root-label" }, [_vm._v("Home")])
              ],
              1
            ),
            _vm.breadcrumbItems.length > 0
              ? [
                  _c("span", { staticClass: "breadcrumb-separator" }, [
                    _vm._v("/")
                  ]),
                  _vm._l(_vm.breadcrumbItems, function(item, index) {
                    return _c(
                      "span",
                      {
                        key: "breadcrumb-" + index,
                        staticClass: "breadcrumb-part"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "breadcrumb-item",
                            class: {
                              "active-breadcrumb":
                                index === _vm.breadcrumbItems.length - 1
                            },
                            on: {
                              click: function($event) {
                                return _vm.navigateToBreadcrumb(index)
                              }
                            }
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        ),
                        index < _vm.breadcrumbItems.length - 1
                          ? _c(
                              "span",
                              { staticClass: "breadcrumb-separator" },
                              [_vm._v("/")]
                            )
                          : _vm._e()
                      ]
                    )
                  })
                ]
              : _vm._e()
          ],
          2
        )
      ]),
      _c("div", { staticClass: "file-explorer-main" }, [
        _c("div", { staticClass: "file-explorer-body" }, [
          _c(
            "div",
            {
              staticClass: "tree-view",
              class: { visible: _vm.treeViewVisible }
            },
            [
              _c(
                "div",
                { staticClass: "tree-section" },
                [
                  _c(
                    "div",
                    { staticClass: "tree-section-title" },
                    [
                      _c("feather-icon", {
                        staticStyle: {
                          "margin-right": "6px",
                          "vertical-align": "middle"
                        },
                        attrs: { icon: "HardDriveIcon", size: "16" }
                      }),
                      _vm._v(" Pastas ")
                    ],
                    1
                  ),
                  _c("file-tree", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.treeViewVisible,
                        expression: "treeViewVisible"
                      }
                    ],
                    ref: "fileTree",
                    attrs: {
                      "root-path": _vm.rootPath,
                      "file-explorer-service": _vm.fileExplorerService,
                      "drive-public-service": _vm.drivePublicService,
                      "current-path": _vm.currentPath
                    },
                    on: {
                      navigate: function(item) {
                        return _vm.handleTreeNavigation(item, false)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.showSharedSection
                ? _c("div", { staticClass: "tree-shared-divider" })
                : _vm._e(),
              _vm.showSharedSection
                ? _c(
                    "div",
                    { staticClass: "tree-section" },
                    [
                      _c(
                        "div",
                        { staticClass: "tree-section-title" },
                        [
                          _c("feather-icon", {
                            staticStyle: {
                              "margin-right": "6px",
                              "vertical-align": "middle"
                            },
                            attrs: { icon: "UsersIcon", size: "16" }
                          }),
                          _vm._v(" Compartilhados comigo ")
                        ],
                        1
                      ),
                      _c("file-tree", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.treeViewVisible,
                            expression: "treeViewVisible"
                          }
                        ],
                        ref: "fileTreeShared",
                        attrs: {
                          "is-shared-context": true,
                          "file-explorer-service": _vm.fileExplorerService,
                          "drive-public-service": _vm.drivePublicService,
                          "current-path": _vm.currentPath
                        },
                        on: {
                          navigate: function(item) {
                            return _vm.handleTreeNavigation(item, true)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _c("div", {
            ref: "divider",
            staticClass: "tree-view-divider",
            class: { visible: _vm.treeViewVisible, dragging: _vm.isDragging },
            on: { mousedown: _vm.startResize }
          }),
          _c("div", { staticClass: "file-content-area" }, [
            _c("div", { staticClass: "file-explorer-content" }, [
              _c("div", [
                _c("h4", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.sectionTitle))
                ]),
                _vm.loading
                  ? _c("div", { staticClass: "loading-indicator" }, [_vm._m(0)])
                  : _vm.error
                  ? _c(
                      "div",
                      { staticClass: "error-container" },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "AlertCircleIcon", size: "24" }
                        }),
                        _c("div", { staticClass: "error-message" }, [
                          _vm._v(_vm._s(_vm.error))
                        ])
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            return _vm.showEmptyAreaContextMenu($event)
                          }
                        }
                      },
                      [
                        _vm.viewMode === "grid"
                          ? _c(
                              "div",
                              { staticClass: "file-list-grid" },
                              [
                                _vm._l(_vm.currentItems, function(item) {
                                  return _c(
                                    "div",
                                    {
                                      key: _vm.getItemUniqueId(item),
                                      staticClass: "file-item",
                                      class: {
                                        selected: _vm.isItemSelected(item),
                                        "drive-item": item.type === "drive"
                                      },
                                      attrs: { title: item.name },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleItemClick(item)
                                        },
                                        dblclick: function($event) {
                                          return _vm.handleItemDoubleClick(item)
                                        },
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.showContextMenu(
                                            $event,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "file-icon" }, [
                                        item.type === "directory"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "file-icon-wrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "file-type-icon file-folder"
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      class: [
                                                        "file-type-feather-icon",
                                                        {
                                                          "folder-open": _vm.isItemSelected(
                                                            item
                                                          )
                                                        }
                                                      ],
                                                      attrs: {
                                                        icon: "FolderIcon",
                                                        size: "28"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : item.type === "drive"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "file-icon-wrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "file-type-icon file-drive"
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      class: [
                                                        "file-type-feather-icon",
                                                        {
                                                          "drive-open": _vm.isItemSelected(
                                                            item
                                                          )
                                                        }
                                                      ],
                                                      attrs: {
                                                        icon: "HardDriveIcon",
                                                        size: "28"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "file-icon-wrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "file-type-icon",
                                                    class: _vm.getFileClass(
                                                      item
                                                    )
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "file-type-feather-icon",
                                                      attrs: {
                                                        icon: _vm.getIconForItem(
                                                          item
                                                        ),
                                                        size: "28"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "file-icon-extension"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getShortExtension(
                                                              item
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                      ]),
                                      _c("div", { staticClass: "file-name" }, [
                                        _vm._v(
                                          _vm._s(_vm.formatFileName(item.name))
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                _vm.currentItems.length === 0
                                  ? _c("div", { staticClass: "empty-folder" }, [
                                      _c(
                                        "div",
                                        { staticClass: "empty-message" },
                                        [_vm._v("Esta pasta está vazia")]
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm.viewMode === "list"
                          ? _c("div", { staticClass: "file-list-table" }, [
                              _c("table", [
                                _c("thead", [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "sortable",
                                        on: {
                                          click: function($event) {
                                            return _vm.sortBy("name")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" Nome "),
                                        _vm.sortColumn === "name"
                                          ? _c(
                                              "span",
                                              { staticClass: "sort-icon" },
                                              [
                                                _c("feather-icon", {
                                                  attrs: {
                                                    icon:
                                                      _vm.sortDirection ===
                                                      "asc"
                                                        ? "ChevronUpIcon"
                                                        : "ChevronDownIcon",
                                                    size: "14"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "sortable",
                                        on: {
                                          click: function($event) {
                                            return _vm.sortBy("type")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" Tipo "),
                                        _vm.sortColumn === "type"
                                          ? _c(
                                              "span",
                                              { staticClass: "sort-icon" },
                                              [
                                                _c("feather-icon", {
                                                  attrs: {
                                                    icon:
                                                      _vm.sortDirection ===
                                                      "asc"
                                                        ? "ChevronUpIcon"
                                                        : "ChevronDownIcon",
                                                    size: "14"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "sortable",
                                        on: {
                                          click: function($event) {
                                            return _vm.sortBy("size")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" Tamanho "),
                                        _vm.sortColumn === "size"
                                          ? _c(
                                              "span",
                                              { staticClass: "sort-icon" },
                                              [
                                                _c("feather-icon", {
                                                  attrs: {
                                                    icon:
                                                      _vm.sortDirection ===
                                                      "asc"
                                                        ? "ChevronUpIcon"
                                                        : "ChevronDownIcon",
                                                    size: "14"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    !_vm.isAccessPublic
                                      ? _c(
                                          "th",
                                          {
                                            staticClass: "sortable",
                                            on: {
                                              click: function($event) {
                                                return _vm.sortBy("owner_name")
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(" Proprietário "),
                                            _vm.sortColumn === "owner_name"
                                              ? _c(
                                                  "span",
                                                  { staticClass: "sort-icon" },
                                                  [
                                                    _c("feather-icon", {
                                                      attrs: {
                                                        icon:
                                                          _vm.sortDirection ===
                                                          "asc"
                                                            ? "ChevronUpIcon"
                                                            : "ChevronDownIcon",
                                                        size: "14"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.currentItems, function(item) {
                                    return _c(
                                      "tr",
                                      {
                                        key: _vm.getItemUniqueId(item),
                                        staticClass: "file-row",
                                        class: {
                                          selected: _vm.isItemSelected(item),
                                          "drive-row": item.type === "drive"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleItemClick(item)
                                          },
                                          dblclick: function($event) {
                                            return _vm.handleItemDoubleClick(
                                              item
                                            )
                                          },
                                          contextmenu: function($event) {
                                            $event.preventDefault()
                                            return _vm.showContextMenu(
                                              $event,
                                              item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("td", { staticClass: "file-cell" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "file-cell-content"
                                            },
                                            [
                                              item.type === "directory"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "file-icon-small"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-type-icon-small file-folder"
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            class: [
                                                              "file-type-feather-icon",
                                                              {
                                                                "folder-open": _vm.isItemSelected(
                                                                  item
                                                                )
                                                              }
                                                            ],
                                                            attrs: {
                                                              icon:
                                                                "FolderIcon",
                                                              size: "14"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : item.type === "drive"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "file-icon-small"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-type-icon-small file-drive"
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            class: [
                                                              "file-type-feather-icon",
                                                              {
                                                                "drive-open": _vm.isItemSelected(
                                                                  item
                                                                )
                                                              }
                                                            ],
                                                            attrs: {
                                                              icon:
                                                                "HardDriveIcon",
                                                              size: "14"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "file-icon-small"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-type-icon-small",
                                                          class: _vm.getFileClass(
                                                            item
                                                          )
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            staticClass:
                                                              "file-type-feather-icon",
                                                            attrs: {
                                                              icon: _vm.getIconForItem(
                                                                item
                                                              ),
                                                              size: "14"
                                                            }
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "file-icon-extension-small"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getShortExtension(
                                                                    item
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "file-cell-name",
                                                  attrs: { title: item.name }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatFileName(
                                                        item.name
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _c("td", [
                                          item.type === "directory" ||
                                          item.type === "drive"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "item-type-with-count"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getTypeLabel(item)
                                                      ) +
                                                      " "
                                                  ),
                                                  _vm.showItemCounts(item)
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "item-count-badge"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.folder_count ||
                                                                  0
                                                              ) +
                                                              " pastas, " +
                                                              _vm._s(
                                                                item.file_count ||
                                                                  0
                                                              ) +
                                                              " arquivos "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatFileType(item)
                                                    ) +
                                                    " "
                                                )
                                              ])
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              item.type === "directory" ||
                                                item.type === "drive"
                                                ? "--"
                                                : _vm.formatFileSize(item.size)
                                            )
                                          )
                                        ]),
                                        !_vm.isAccessPublic
                                          ? _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  item.is_owner
                                                    ? "Eu"
                                                    : item.owner_name || "--"
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]),
                              _vm.currentItems.length === 0
                                ? _c("div", { staticClass: "empty-folder" }, [
                                    _c(
                                      "div",
                                      { staticClass: "empty-message" },
                                      [_vm._v("Esta pasta está vazia")]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    )
              ])
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "file-explorer-footer" }, [
        _c("div", { staticClass: "item-count" }, [
          _vm._v(_vm._s(_vm.itemCountText))
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.contextMenuVisible,
              expression: "contextMenuVisible"
            }
          ],
          staticClass: "context-menu",
          style: _vm.contextMenuStyle
        },
        [
          _vm.contextMenuItem
            ? _c(
                "div",
                [
                  _vm.contextMenuItem.type === "drive"
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "open",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "HardDriveIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Abrir drive")])
                          ],
                          1
                        ),
                        _vm.contextMenuItem.is_owner
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "drive.share_drive",
                                    expression: "'drive.share_drive'"
                                  }
                                ],
                                staticClass: "context-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.handleContextMenuAction(
                                      "share",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "context-menu-icon",
                                  attrs: { icon: "ShareIcon", size: "14" }
                                }),
                                _c("span", [_vm._v("Compartilhar")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "drive.download_drive",
                                expression: "'drive.download_drive'"
                              }
                            ],
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "downloadZip",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "DownloadCloudIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Baixar como ZIP")])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "details",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "InfoIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Detalhes")])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "drive.sharing_info",
                                expression: "'drive.sharing_info'"
                              }
                            ],
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "sharing-info",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "UsersIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Ver compartilhamentos")])
                          ],
                          1
                        )
                      ]
                    : _vm.contextMenuItem.type === "directory"
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "open",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "FolderIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Abrir pasta")])
                          ],
                          1
                        ),
                        _vm.contextMenuItem.is_owner
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "drive.share_directory",
                                    expression: "'drive.share_directory'"
                                  }
                                ],
                                staticClass: "context-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.handleContextMenuAction(
                                      "share",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "context-menu-icon",
                                  attrs: { icon: "ShareIcon", size: "14" }
                                }),
                                _c("span", [_vm._v("Compartilhar")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "drive.download_directory",
                                expression: "'drive.download_directory'"
                              }
                            ],
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "downloadZip",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "DownloadCloudIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Baixar como ZIP")])
                          ],
                          1
                        ),
                        _vm.contextMenuItem.is_owner
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "drive.rename_directory",
                                    expression: "'drive.rename_directory'"
                                  }
                                ],
                                staticClass: "context-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.handleContextMenuAction(
                                      "rename",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "context-menu-icon",
                                  attrs: { icon: "EditIcon", size: "14" }
                                }),
                                _c("span", [_vm._v("Renomear")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.contextMenuItem.is_owner
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "drive.delete_directory",
                                    expression: "'drive.delete_directory'"
                                  }
                                ],
                                staticClass: "context-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.handleContextMenuAction(
                                      "delete",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "context-menu-icon",
                                  attrs: { icon: "Trash2Icon", size: "14" }
                                }),
                                _c("span", [_vm._v("Excluir")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "details",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "InfoIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Detalhes")])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "drive.sharing_info",
                                expression: "'drive.sharing_info'"
                              }
                            ],
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "sharing-info",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "UsersIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Ver compartilhamentos")])
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "download",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "DownloadIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Download")])
                          ],
                          1
                        ),
                        _vm.contextMenuItem.is_owner
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "drive.share_file",
                                    expression: "'drive.share_file'"
                                  }
                                ],
                                staticClass: "context-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.handleContextMenuAction(
                                      "share",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "context-menu-icon",
                                  attrs: { icon: "ShareIcon", size: "14" }
                                }),
                                _c("span", [_vm._v("Compartilhar")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.contextMenuItem.is_owner
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "drive.rename_file",
                                    expression: "'drive.rename_file'"
                                  }
                                ],
                                staticClass: "context-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.handleContextMenuAction(
                                      "rename",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "context-menu-icon",
                                  attrs: { icon: "EditIcon", size: "14" }
                                }),
                                _c("span", [_vm._v("Renomear")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.contextMenuItem.is_owner
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "drive.delete_file",
                                    expression: "'drive.delete_file'"
                                  }
                                ],
                                staticClass: "context-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.handleContextMenuAction(
                                      "delete",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "context-menu-icon",
                                  attrs: { icon: "Trash2Icon", size: "14" }
                                }),
                                _c("span", [_vm._v("Excluir")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "details",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "InfoIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Detalhes")])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "drive.sharing_info",
                                expression: "'drive.sharing_info'"
                              }
                            ],
                            staticClass: "context-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleContextMenuAction(
                                  "sharing-info",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "context-menu-icon",
                              attrs: { icon: "UsersIcon", size: "14" }
                            }),
                            _c("span", [_vm._v("Ver compartilhamentos")])
                          ],
                          1
                        )
                      ]
                ],
                2
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.emptyAreaContextMenuVisible,
              expression: "emptyAreaContextMenuVisible"
            }
          ],
          staticClass: "context-menu",
          style: _vm.emptyAreaContextMenuStyle
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "drive.upload",
                  expression: "'drive.upload'"
                }
              ],
              staticClass: "context-menu-item",
              class: { disabled: _vm.isRootLevel },
              on: {
                click: function($event) {
                  _vm.isRootLevel
                    ? null
                    : _vm.handleEmptyAreaContextMenuAction("upload", $event)
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "context-menu-icon",
                attrs: { icon: "UploadIcon", size: "14" }
              }),
              _c("span", [_vm._v("Upload de arquivo")])
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "drive.create_directory",
                  expression: "'drive.create_directory'"
                }
              ],
              staticClass: "context-menu-item",
              class: { disabled: _vm.isRootLevel },
              on: {
                click: function($event) {
                  _vm.isRootLevel
                    ? null
                    : _vm.handleEmptyAreaContextMenuAction("newFolder", $event)
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "context-menu-icon",
                attrs: { icon: "FolderPlusIcon", size: "14" }
              }),
              _c("span", [_vm._v("Nova pasta")])
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "context-menu-item",
              on: {
                click: function($event) {
                  return _vm.handleEmptyAreaContextMenuAction("refresh", $event)
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "context-menu-icon",
                attrs: { icon: "RefreshCwIcon", size: "14" }
              }),
              _c("span", [_vm._v("Atualizar")])
            ],
            1
          )
        ]
      ),
      _vm.showRenameModal
        ? _c(
            "div",
            {
              staticClass: "rename-modal-backdrop",
              on: { click: _vm.cancelRename }
            },
            [
              _c(
                "div",
                {
                  staticClass: "rename-modal",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "rename-modal-header" }, [
                    _c("h3", [
                      _vm._v(
                        " Renomear " +
                          _vm._s(
                            _vm.renameItem &&
                              _vm.renameItem.type === "directory"
                              ? "Pasta"
                              : "Arquivo"
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "close-button",
                        on: { click: _vm.cancelRename }
                      },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "XIcon", size: "18" }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "rename-modal-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "newName" } }, [
                        _vm._v("Novo nome:")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newItemName,
                            expression: "newItemName"
                          }
                        ],
                        ref: "renameInput",
                        staticClass: "form-control",
                        attrs: { type: "text", id: "newName" },
                        domProps: { value: _vm.newItemName },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.confirmRename($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.newItemName = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "rename-modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        on: { click: _vm.cancelRename }
                      },
                      [_vm._v("Cancelar")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { disabled: !_vm.newItemName || _vm.isRenaming },
                        on: { click: _vm.confirmRename }
                      },
                      [
                        _vm.isRenaming
                          ? _c(
                              "div",
                              {
                                staticClass: "spinner-border spinner-border-sm",
                                attrs: { role: "status" }
                              },
                              [
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Renomeando...")
                                ])
                              ]
                            )
                          : _c("span", [_vm._v("Renomear")])
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm.showPreviewModal
        ? _c("file-preview-modal", {
            attrs: {
              show: _vm.showPreviewModal,
              file: _vm.previewFile,
              "preview-url": _vm.previewUrl
            },
            on: { close: _vm.closePreview, download: _vm.handlePreviewDownload }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }